import React from "react";
import Badge from "react-bootstrap/Badge";

const Status = ({value}) => {
  const colorMapping = {
    active: 'success',
    inactive: 'secondary',
  }
  let displayValue = value
  if (value === 'active') displayValue = 'activ'
  if (value === 'inactive') displayValue = 'inactiv'

  return <Badge bg={colorMapping[value]}>{displayValue}</Badge>
}

export default Status;